import { AddCircleIcon } from '@/assets';
import { Button } from '@tremor/react';
import { ComponentProps, FC } from 'react';
import s from './FlatAddButton.module.scss';

type Props = Omit<ComponentProps<typeof Button>, 'icon' | 'iconPosition'>;

export const FlatAddButton: FC<Props> = ({ children, className, ...rest }) => {
  return (
    <Button
      {...rest}
      className={[className, s.FlatAddButton].join(' ')}
      icon={() => <img alt="circle add icon" src={AddCircleIcon} />}
    >
      {children}
    </Button>
  );
};
